<template>
  <div class="owner-info mb-3">
    <v-card tile class="elevation-0">
      <v-card-text class="pb-0">
        <v-row dense>
          <slot name="prepend"></slot>

          <v-col cols="3">
            <text-field-like
                :value="view.terminalName"
                :value-id="view.terminalId"
                :label="isTerminalOurself ? '所属先サイト名' : 'サイト名'"
                hide-details>
            </text-field-like>
          </v-col>

          <v-col cols="3">
            <text-field-like
                :value="view.ownerName"
                :value-id="view.ownerId"
                :label="isOwnerOurself ? '所属先事業者名' : '事業者名'"
                hide-details>
              <template #default="{value}" v-if="showDetail">
                {{ value }}
                <icon-btn
                    type="view"
                    tooltip="事業者詳細"
                    tooltip-placement="right"
                    @click="ownerInfoDialog = view.ownerId"
                    style="margin-top: -3px;"
                    class="ml-2"
                    x-small>
                </icon-btn>
              </template>
            </text-field-like>
          </v-col>

          <slot name="append"></slot>
        </v-row>
      </v-card-text>
    </v-card>

    <owner-info-dialog
        v-model="ownerInfoDialog">
    </owner-info-dialog>
  </div>
</template>

<script>
import OwnerInfoDialog from "@/components/organisms/OwnerInfoDialog.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {mapGetters} from "vuex";
import IconBtn from "@/components/molecules/IconBtn.vue";
export default {
  name: 'OwnerInfo',
  components: {IconBtn, TextFieldLike, OwnerInfoDialog},
  props: {
    account: {
      type: Object,
      required: true
    },
    showDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ownerInfoDialog: false
    };
  },
  computed: {
    ...mapGetters({
      _account: 'hcs/account',
    }),
    isOwnerOurself() {
      return this.view.ownerId === this._account.owner?.id;
    },
    isTerminalOurself() {
      return this.view.terminalId === this._account.user?.terminalId;
    },
    view() {
      if('ownerId' in this.account) {
        return this.account;
      }
      const owner = this.account.owner, user = this.account.user;
      return {
        ownerId: owner?.id || '',
        ownerName: owner?.name || '',
        terminalId: user?.terminal?.id || '',
        terminalName: user?.terminal?.name || '',
        pollingRate: user?.terminal?.pollingRate ?? ''
      };
    }
  },
}
</script>

<style lang="scss" scoped>
.v-card .v-card__subtitle {
  padding: 0;
  color: black !important;
  font-size: 110%;
  font-weight: 500;
}
</style>
